import {styled} from '@mui/system'

export const TwoColumnsGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '16px',
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr'
  }
})

export const ThreeColumnsGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  columnGap: '16px',
  rowGap: '16px',
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr'
  }
})

export const StepperGreyContainer = styled('div')({
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #F0F0F0',
  margin: '0 -30px',
  padding: '12px 30px'
})

export const BoldLabelsFormWrapper = styled('div')({
  '.ant-form-item-label > label': {
    fontWeight: 600
  },
  '.ant-input, .ant-input-number, .ant-picker': {
    borderRadius: '16px'
  },
  '.ant-select-selector': {
    borderRadius: '16px !important'
  },
  '.ant-input-number-group > .ant-input-number': {
    borderTopRightRadius: '0 !important',
    borderBottomRightRadius: '0 !important'
  },
  '.ant-input-number-group-addon': {
    backgroundColor: '#e8e8e8',
    borderTopLeftRadius: '0 !important',
    borderBottomLeftRadius: '0 !important',
    borderTopRightRadius: '16px !important',
    borderBottomRightRadius: '16px !important'
  },
  '.ant-input-number-group-addon .ant-select-selector': {
    borderRadius: '0 !important'
  }
})
